import { memo, useMemo } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import type { ReactNode } from 'react';

export type LayoutEditorTabKey = 'sections' | 'style' | 'colors' | 'view';

interface LayoutEditorTabsProps {
  activeKey: LayoutEditorTabKey;
  onChange: (key: LayoutEditorTabKey) => void;
  sectionsTab: ReactNode;
  styleTab: ReactNode;
  colorsTab: ReactNode;
  viewTab: ReactNode;
  visibleTabs?: LayoutEditorTabKey[];
}

const LayoutEditorTabsComponent = ({
  activeKey,
  onChange,
  sectionsTab,
  styleTab,
  colorsTab,
  viewTab,
  visibleTabs,
}: LayoutEditorTabsProps) => {
  const items = useMemo<TabsProps['items']>(
    () => [
      {
        key: 'sections',
        label: 'Secciones',
        children: sectionsTab,
      },
      {
        key: 'style',
        label: 'Estilo',
        children: styleTab,
        forceRender: true,
      },
      {
        key: 'colors',
        label: 'Colores',
        children: colorsTab,
        forceRender: true,
      },
      {
        key: 'view',
        label: 'Vista',
        children: viewTab,
      },
    ].filter((item) => !visibleTabs || visibleTabs.includes(item.key as LayoutEditorTabKey)),
    [sectionsTab, styleTab, colorsTab, viewTab, visibleTabs],
  );

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => onChange(key as LayoutEditorTabKey)}
      items={items}
      className="layout-editor-tabs"
      destroyOnHidden={false}
      animated={{ inkBar: true, tabPane: false }}
      moreIcon={null}
      tabBarGutter={8}
      tabBarExtraContent={null}
    />
  );
};

const LayoutEditorTabs = memo(LayoutEditorTabsComponent);

export default LayoutEditorTabs;
